import accordion from './accordion'
import avatar from './avatar'
import badge from './badge'
import breadcrumb from './breadcrumb'
import button from './button'
import calendar from './calendar'
import card from './card'
import checkbox from './checkbox'
import chip from './chip'
import contextmenu from './contextmenu'
import datatable from './datatable'
import dialog from './dialog'
import divider from './divider'
import dropdown from './dropdown'
import fileUpload from './file-upload'
import floatlabel from './floatlabel'
import global from './global.js'
import iconfield from './iconfield'
import inputgroup from './inputgroup'
import inputgroupaddon from './inputgroupaddon'
import inputnumber from './inputnumber'
import inputswitch from './inputswitch'
import inputtext from './inputtext'
import menu from './menu'
import message from './message'
import multiselect from './multiselect'
import overlaypanel from './overlaypanel'
import paginator from './paginator'
import panelmenu from './panelmenu'
import password from './password'
import skeleton from './skeleton'
import stepper from './stepper'
import steps from './steps'
import tabmenu from './tabmenu'
import tag from './tag'
import textarea from './textarea'
import toast from './toast'
import tooltip from './tooltip'

export default {
  accordion,
  avatar,
  badge,
  breadcrumb,
  button,
  calendar,
  card,
  checkbox,
  chip,
  contextmenu,
  datatable,
  dialog,
  directives: { tooltip },
  divider,
  dropdown,
  fileUpload,
  floatlabel,
  global,
  iconfield,
  inputgroup,
  inputgroupaddon,
  inputnumber,
  inputswitch,
  inputtext,
  menu,
  message,
  multiselect,
  overlaypanel,
  paginator,
  panelmenu,
  password,
  skeleton,
  stepper,
  steps,
  tabmenu,
  tag,
  textarea,
  toast,
}
